/* eslint-disable react/prop-types */
import React from 'react';

import { isCioColorFacet } from '../../utils/filters';

import DesktopGridColorFilter from './DesktopGridColorFilter';
import DesktopGridDefaultFilter from './DesktopGridDefaultFilter';
import DesktopGridFilterGroupDisclosure from './DesktopGridFilterGroupDisclosure';
import DesktopGridGroupedFilter from './DesktopGridGroupedFilter';

const DesktopGridFilterRenderer = ({ facet, togglePanel, openPanels }) => {
  if (facet?.sub_facets?.length > 0) {
    return (
      <DesktopGridFilterGroupDisclosure
        {...facet}
        togglePanel={togglePanel}
        openPanels={openPanels}
      >
        <DesktopGridGroupedFilter {...facet} />
      </DesktopGridFilterGroupDisclosure>
    );
  }

  if (isCioColorFacet(facet?.name)) {
    return (
      <DesktopGridFilterGroupDisclosure
        {...facet}
        togglePanel={togglePanel}
        openPanels={openPanels}
      >
        <DesktopGridColorFilter {...facet} />
      </DesktopGridFilterGroupDisclosure>
    );
  }

  return (
    <DesktopGridFilterGroupDisclosure
      {...facet}
      togglePanel={togglePanel}
      openPanels={openPanels}
    >
      <DesktopGridDefaultFilter {...facet} />
    </DesktopGridFilterGroupDisclosure>
  );
};

export default DesktopGridFilterRenderer;
